function onClassChange(selector, callback) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        callback(mutation.target);
      }
    });
  });
  const element = document.querySelector(selector);
  observer.observe(element, { attributes: true });
  return observer.disconnect;
}

document.addEventListener('DOMContentLoaded', function() {
  function getCurrentVariantValues() {
    const variantPicker = document.querySelector('variant-radios');
    if (variantPicker) {
      return productOptions.map(option => {
        const selectedVariant = variantPicker.currentVariant
        return {
          name: option.name,
          value: selectedVariant[`option${option.position}`]
        }
      });
    } else {
      return [];
    }
  }

  document.addEventListener("globo.preorder.show.bis", function () {
    if (document.querySelector('.Globo-form-popup')) {
      // back-in-stock popup opened
      const notifyFormProductTitle = document.querySelector('.Globo-form-popup .Globo-product-title');
      notifyFormProductTitle.innerHTML = productTitle;
      const productVariant = getCurrentVariantValues();
      if (productVariant.length) {
        variantInfo = document.createElement('div');
        variantInfo.innerHTML = productVariant.map(variant => `${variant.name}: ${variant.value}`).join('<br>');
        notifyFormProductTitle.parentNode.insertBefore(variantInfo, notifyFormProductTitle.nextSibling);
      }

      // wait until ajax submission is done
      onClassChange('.gSubscribeBtn', function (submitButton) {
        const existingErrorIcons = document.querySelectorAll('.error-icon-custom');
          if (existingErrorIcons.length) {
            existingErrorIcons.forEach(icon => {
              icon.remove();
            })
          }
          
        if (submitButton.classList.contains('button--loading')) {
          return;
        }

        setTimeout(() => {
          const emailInput = document.querySelector('input.gBackInStock-Form-Content-Input[type="email"]');
          const resultMessageElement = document.querySelector('.gBackInStock-Message');
          const resultMessage = resultMessageElement.textContent;
          
          if (resultMessage && resultMessage.trim().length) {
            showToast({ message: resultMessage });
            document.querySelector('.Globo-header-close').click();
          } else {
            const errorIcon = document.createElement('div');
            errorIcon.classList.add('error-icon-custom');
            errorIcon.innerHTML = '<svg width="24" height="24" aria-hidden="true" type="image/svg+xml" viewBox="0 0 24 24" fill="#e93c3c" xmlns="http://www.w3.org/2000/svg" ><path fill-rule="evenodd" clip-rule="evenodd" d="M3.87436 21H20.1144H20.1244C21.5535 21 22.4529 19.5035 21.7634 18.2864L13.6484 3.95026C12.9388 2.68325 11.0699 2.68325 10.3604 3.95026L2.23537 18.2964C1.5458 19.5135 2.45524 21 3.87436 21ZM10.99 13.9374L10.7002 9.09887V7.75205C10.7002 7.33304 11.04 6.99384 11.4597 6.99384H12.609C13.0288 6.99384 13.3686 7.33304 13.3686 7.75205V9.10884L13.0887 13.9275C13.0687 14.3265 12.7389 14.6358 12.3292 14.6358H11.7495C11.3498 14.6358 11.02 14.3265 10.99 13.9275V13.9374ZM11.9994 18.9652C12.7887 18.9652 13.4286 18.3265 13.4286 17.5386C13.4286 16.7507 12.7887 16.112 11.9994 16.112C11.2102 16.112 10.5703 16.7507 10.5703 17.5386C10.5703 18.3265 11.2102 18.9652 11.9994 18.9652Z"></path></svg>';
            emailInput.parentNode.insertBefore(errorIcon, emailInput.nextSibling);
          }
        }, 100);
      })
    }
  });
});
